import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Dashboard from './pages/dashboard/Dashboard';
import NewActivity from './pages/activity/NewActivity';
import Login from './pages/user/Login';
import Register from './pages/user/Register';
import PrivateRoute from './auth/PrivateRoute';
import { UserProvider } from './context/UserContext';
import NotificationHandler from '../src/components/utils/NotificationHandler';
import AllActivity from './pages/activity/AllActivity';
import ActivityDetails from './pages/activity/ActivityDetails';
import ClosedActivities from './pages/activity/ClosedActivities';

const App = () => {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} />
      <UserProvider>
        <NotificationHandler />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<PrivateRoute />}>
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<Dashboard />} />
            <Route path="/new-activity" element={<NewActivity />} />
            <Route path='/closed-activity' element={<ClosedActivities />} />
            <Route path='/all-activity' element={<AllActivity />} />
            <Route path='/activity-details/:id' element={<ActivityDetails />} />
          </Route>
        </Routes>
      </UserProvider>
    </Router>
  );
};

export default App;
